/**
 * Localstorage (currently) cache of test and metabolic profile details
 */

import { Injectable, inject } from '@angular/core';
import { BrowserStorageService } from './browser-storage.service';
import { AppConstants } from '@core/constants';

@Injectable({ providedIn: 'root' })
export class TestCache {
  private readonly browserStorage = inject(BrowserStorageService);

  cacheTest(testData: Record<string, any>): void {
    this.browserStorage.setObjectItem(AppConstants.REPORT_STORAGE.KEY, testData);
  }

  cacheMetabolicProfile(profileData: Array<Record<string, any>>): void {
    const profileKey = [AppConstants.REPORT_STORAGE.KEY, 'profile'].join('_');
    this.browserStorage.setObjectItem(profileKey, profileData);
  }

  cacheMetabolicProfileParts(profileData: Array<Record<string, any>>): void {
    Object.entries(AppConstants.REPORT_STORAGE.TAB_INDEX).forEach(([_, tabIndex]) => {
      const tabKey = [AppConstants.REPORT_STORAGE.KEY, 'profile', tabIndex].join('_');
      const tabData = (profileData ?? [])[tabIndex];
      if (tabData != null) {
        this.browserStorage.setObjectItem(tabKey, tabData);
      } else {
        this.browserStorage.removeItem(tabKey);
      }
    });
  }

  getTest(testId: number): Record<string, any> | null {
    const test = this.browserStorage.getObjectItem<Record<string, any>>(AppConstants.REPORT_STORAGE.KEY);
    return test?.id === testId ? test : null;
  }

  getMetabolicProfile(testId: number): Array<Record<string, any>> | null {
    const profileKey = [AppConstants.REPORT_STORAGE.KEY, 'profile'].join('_');
    const test = this.browserStorage.getObjectItem<Record<string, any>>(AppConstants.REPORT_STORAGE.KEY);

    return test?.id === testId ? this.browserStorage.getObjectItem<Array<Record<string, any>>>(profileKey) : null;
  }
}
